import _ from 'lodash'

/**
 * Maps array of numbers to each number's percent of the array's sum. Preserves input order.
 * @param numberArray
 * @returns {Number[]}
 */
export function getPercentages(numberArray) {
  const sum = _.sum(numberArray)
  const values = _.map(numberArray, (value, index) => {
    const percent = (value / sum) * 100
    return {
      originalIndex: index,
      percent: percent,
      int: Math.floor(percent),
      decimal: percent % 1
    }
  })
  const sortedByDecimal = _.orderBy(values, 'decimal', 'desc')
  let percentSum = _.sum(_.map(values, 'int'))
  let indexToIncrement = 0
  while (percentSum < 100) {
    values[sortedByDecimal[indexToIncrement].originalIndex].int++
    indexToIncrement++
    percentSum++
  }
  return _.map(values, it => {
    return _.isNaN(it.int) ? 0 : it.int
  })
}
